"use client";

import { useAppSelector } from "@/hooks/useAppSelector";
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { Search } from "lucide-react";
import MobileProductCard from "./MobileProductCard";
import MobileCategoryFilter from "./MobileCategoryFilter";

const MobileProductList = () => {
  const { products } = useAppSelector((state) => state.home);
  const { selectedFilters } = useAppSelector((state) => state.steps);
  const [searchQuery, setSearchQuery] = useState("");

  const filteredProducts = products?.filter((product) => {
    const matchesSearch =
      product.prod_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      product.Bar_Code?.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesFilters =
      selectedFilters?.length === 0 ||
      selectedFilters?.some(
        (filter) => product.SubcategorieName === filter.SubcategorieName
      );

    return matchesSearch && matchesFilters;
  });

  return (
    <div className="w-full p-4">
      <div className="mb-4 flex items-center gap-2">
        <div className="relative bg-white-1 rounded-md flex-1">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input
            placeholder="Search products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-9 text-sm text-black-1"
          />
        </div>
        <MobileCategoryFilter />
      </div>

      <div className="h-full pr-2">
        <div className="flex flex-col gap-4">
          {filteredProducts?.length ? (
            filteredProducts.map((product) => (
              <MobileProductCard key={product.SKU_ID} data={product} />
            ))
          ) : (
            <Card className="p-4 text-sm text-center text-muted-foreground">
              No products found.
            </Card>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileProductList;
